import { Helmet } from "react-helmet";

const ORIGIN = (typeof window !== "undefined" && window.location.origin) || "https://allhomedesire.com";

/**
 * Per-page meta tags: title, description, canonical URL, Open Graph, Twitter and optional JSON-LD.
 * `path` is the canonical path of the page (e.g. "/blogs/my-post").
 */
const Seo = ({ title, description, path = "/", image, type = "website", jsonLd }) => {
  const url = `${ORIGIN}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="All Home Desire" />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
export { ORIGIN };
